<iframe #formBuilderContainer frameborder="0" height="100%" width="100%" allowfullscreen="" allow="microphone" [src]="vFormsUrl"></iframe>